import { render, staticRenderFns } from "./AttributeGet.vue?vue&type=template&id=4a52cc3c&scoped=true"
import script from "./AttributeGet.vue?vue&type=script&lang=js"
export * from "./AttributeGet.vue?vue&type=script&lang=js"
import style0 from "./AttributeGet.vue?vue&type=style&index=0&id=4a52cc3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a52cc3c",
  null
  
)

export default component.exports